import { render, staticRenderFns } from "./BestSellingProducts.vue?vue&type=template&id=6b80ecf7"
import script from "./BestSellingProducts.vue?vue&type=script&lang=js"
export * from "./BestSellingProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports